var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 8.43v.32c0 3.34-2.37 7.2-6.72 7.2A6.39 6.39 0 015.5 14.8 4.55 4.55 0 009 13.76a2.4 2.4 0 01-2.2-1.75 2.24 2.24 0 001.06-.04 2.5 2.5 0 01-1.9-2.48v-.04c.32.2.69.3 1.08.32a2.64 2.64 0 01-.73-3.38 6.59 6.59 0 004.87 2.65 2.55 2.55 0 01-.06-.58c0-1.4 1.06-2.53 2.36-2.53.68 0 1.3.3 1.73.8a4.55 4.55 0 001.5-.61 2.5 2.5 0 01-1.04 1.4c.48-.07.94-.2 1.36-.4-.32.5-.72.95-1.18 1.3",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgTwitterIcon;